const checkout = {
  isLoading: {
    cart: true,
    deliveryDates: false,
    deliveryAddresses: false,
    summary: false,
    creditCards: false,
    newAddressForm: false,
    newCreditCardForm: false,
    couponLoading: false,
  },
  cart: {
    id: 0,
    memberid: 0,
    subtotal: 0.0,
    discount: 0.0,
    tax: 0.0,
    selectedCreditCardSurcharge: 0.0,
    pointsEarned: 0,
    statusCredits: 0,
    shippingCost: 0.0,
    creditCardFee: 0.0,
    handlingFee: 0.0,
    total: 0.0,
    minimumDeliveryFee: 0.0,
    hasConsolidationDay: false,
    ExtraAttribute1: 0.0,
    PaymentMethod: '',
    prepaidBalanceUsed: 0.0,
    appliedSurchargeTotal: 0.0,
    discountTotal: 0,
    appliedDiscountCoupons: [],
    appliedSurcharges: [],
    list: [],
  },
  details: {
    selectedPaymentMethod: '',
    selectedCreditCard: '',
    selectedDeliveryDate: '',
    selectedDeliveryDateToBeConfirmed: '',
    selectedDeliveryAddress: '',
    selectedDeliveryAddressObj: {},
    reference: '',
    notes: '',
    selectedShippingMethod: '1',
    urgentDelivery: false,
    urgentPickupThreepl: false,
    pickupEmptyKegs: false,
    couponCode: '',
    isCouponApplied: false,
    isCouponValid: true,
  },
  availableDeliveryDates: [],
  availableDeliveryAddresses: [],
  availableCreditCards: [],
  newAddressForm: {
    unitNumber: '',
    streetNumber: '',
    streetNumber2: '',
    streetName: '',
    address: '',
    suburb: '',
    state: '',
    postcode: '',
    country: 'AU',
  },
  newCreditCardForm: {
    cardName: '',
    cardExpiryMonth: '',
    cardExpiryYear: '',
    validNumber: false,
    validCvv: false,
    cvvLength: 0,
    numberLength: 0,
  },
  readGlobalConfig: {
    checkoutPaymentMethods: [],
    useCurrentCards: false,
    lastUsedPaymentMethod: '',
    enableCCAuthorization: false,
  },
  readShippingMethod: {
    checkoutShippingMethods: [],
  },
}

const CheckoutReducer = function (state = checkout, action) {
  switch (action.type) {
    case 'SET_CHECKOUT_GLOBAL_CONFIG': {
      return {
        ...state,
        readGlobalConfig: {
          checkoutPaymentMethods: action.value?.CheckoutPaymentMethods,
          useCurrentCards: action.value?.UseCurrentCards,
          lastUsedPaymentMethod: action.value?.LastUsedPaymentMethod,
          userTermType: action.value?.UserTermType,
          enableCCAuthorization: action?.value?.EnableCCAuthorization,
        },
      }
    }
    case 'SET_CHECKOUT_SHIPPING_METHOD': {
      return {
        ...state,
        readShippingMethod: {
          checkoutShippingMethods: action.value,
        },
      }
    }
    case 'TOGGLE_CHECKOUT_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_CHECKOUT_DETAILS': {
      return {
        ...state,
        details: {
          ...state.details,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_CHECKOUT_CART_DETAILS': {
      return {
        ...state,
        cart: {
          ...state.cart,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_CHECKOUT_ADDRESS_FORM': {
      return {
        ...state,
        newAddressForm: {
          ...state.newAddressForm,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_CHECKOUT_CREDIT_CARD_FORM': {
      return {
        ...state,
        newCreditCardForm: {
          ...state.newCreditCardForm,
          [action.key]: action.value,
        },
      }
    }
    case 'REPLACE_CHECKOUT_CART_DETAILS': {
      return {
        ...state,
        cart: {
          ...state.cart,
          ...action.details,
        },
      }
    }
    case 'UPDATE_CHECKOUT_CART': {
      return {
        ...state,
        cart: {
          ...state.cart,
          list: action.cart,
        },
      }
    }
    case 'UPDATE_AVAILABLE_DELIVERY_DATES': {
      return {
        ...state,
        availableDeliveryDates: action.value,
      }
    }
    case 'UPDATE_AVAILABLE_DELIVERY_ADDRESSES': {
      return {
        ...state,
        availableDeliveryAddresses: action.value,
      }
    }
    case 'UPDATE_AVAILABLE_CREDIT_CARDS': {
      return {
        ...state,
        availableCreditCards: action.value,
      }
    }
    case 'UPDATE_SELECTED_DELIVERY_ADDRESS': {
      const foundAddress = state.availableDeliveryAddresses.find((item) => {
        return item.id == action.value
      })

      let selectedDeliveryAddressObj = {}
      if (foundAddress) {
        selectedDeliveryAddressObj = foundAddress
      }

      return {
        ...state,
        details: {
          ...state.details,
          selectedDeliveryAddress: action.value,
          selectedDeliveryAddressObj: selectedDeliveryAddressObj,
        },
      }
    }
    case 'CLEAR_NEW_ADDRESS_FORM': {
      return {
        ...state,
        newAddressForm: {
          ...state.newAddressForm,
          unitNumber: '',
          streetNumber: '',
          streetNumber2: '',
          streetName: '',
          address: '',
          suburb: '',
          // state: '', // Don't change this so we will always use whatever that has been set
          postcode: '',
          // country: 'AU',  // Don't change this so we will always use whatever that has been set
        },
      }
    }
    case 'CLEAR_NEW_CREDIT_CARD_FORM': {
      return {
        ...state,
        newCreditCardForm: {
          cardName: '',
          cardNumber: '',
          cardExpiryMonth: '',
          cardExpiryYear: '',
          cardCVV: '',
        },
      }
    }
    case 'CLEAR_CHECKOUT_CART': {
      return {
        ...state,
        cart: checkout.cart,
      }
    }
    default: {
      return state
    }
  }
}

export default CheckoutReducer
